import React, { Component } from 'react'
import { Link, browserHistory } from 'react-router'
import Filter from './../Filter'
import EmptyCat from './components/EmptyCat'

var List = React.createClass({
  handlerFilter: function(data, type){
    var obj = { ...this.state };
    obj.filter[type] = data;
    this.setState(obj);
  },
  handlerDataFilter: function(data){
    this.setState({dataFilter: data})
  },
  handlerFil: function(data){
    this.setState(data)
  },
  getInitialState: function(){
    return({
      filter: {
        default: function(){return true}
      },
      dataFilter: {
        open: false,
        date: false,
        dateData: {
          select: false
        },
        status: false,
        statusData: {
          select: false
        },
        search: '',
      }
    })
  },
  render: function(){
    if(this.props.specialties){
      console.log('specialties');

      var sdfsdf = this.props.specialties.sort(function(a, b) {
        var blockB = typeof b.profiles.length == 'undefined' ? 0 : b.profiles.length,
            blockA = typeof a.profiles.length == 'undefined' ? 0 : a.profiles.length;

        return blockB - blockA;
      });

      return(
        <div>
          {this.props.specialties.map((specialty, i) => {
            if(specialty.profiles.length){
              return(
                <Link key={specialty.id} to={`/admin/specialty/${specialty.id}/`} className="SelectSpecialtiesOpen">{specialty.VacancyName} {"(" + (specialty.count ? specialty.count : typeof specialty.profiles != 'undefined' ? specialty.profiles.length : '0') + ")"}</Link>
              );
            }else{
              return(
                <div key={specialty.id} className="SelectSpecialtiesOpen disable">{specialty.VacancyName} {"(" + (typeof specialty.profiles != 'undefined' ? specialty.profiles.length : '0') + ")"}</div>
              );
            }

          })}
        </div>
      );
    }else if(this.props.profiles){
      // console.log('this.props.profiles', this.props.profiles)
      if(this.props.profiles.length != 0){
        return(
          <div>
            <Link className="SelectSpecialtiesOpen top" to="/admin/">Назад</Link>
            <Filter data={this.state.dataFilter} data2={this.state} actionFil={this.handlerFil} actionDataFilter={this.handlerDataFilter} actionFilter={this.handlerFilter} />
            <div class="headlineWrapper"><div class="headline">Соискатели ({this.props.profiles.length})</div></div>
            {this.props.profiles.map((profile, i) => {
              var statusClassName = '',
                  arrFilter = [],
                  status = profile.status,
                  statusRussia = '',
                  statusColorStyle = { width: '20%'},
                  statusColorStyle2 = { width: '5%', color: 'red' },
                  status1C = profile.status1C;

              if(status1C){
                if(status1C == '0'){
                  statusColorStyle.color = 'black';
                  statusRussia = 'Ожидает обработки';
                }else if(status1C == '1'){
                  statusColorStyle.color = 'blue';
                  statusRussia = 'В обработке';
                }else if(status1C == '2'){
                  statusColorStyle.color = 'green';
                  statusRussia = 'Принят на работу';
                }else if(status1C == '3'){
                  statusColorStyle.color = 'red';
                  statusRussia = 'Отказано';
                }
              }else{
                if(status === true || status === 'true' || status === 1 || status === '1'){
                  statusClassName = 'true';
                  statusRussia = 'Успех'
                  statusColorStyle.color = 'green';
                }else if(status === false || status == 'false' || status === 2 || status === '2'){
                  statusClassName = 'false';
                  statusRussia = 'Уволен'
                  statusColorStyle.color = 'red';
                }else if(status === 3 || status === '3'){
                  statusClassName = 'work';
                  statusRussia = 'Работает'
                  statusColorStyle.color = 'blue';
                }else if(status === 4 || status === '4'){
                  statusClassName = 'dismiss';
                  statusColorStyle.color = 'red';
                  statusRussia = 'Отказ'
                }else if(status === 5 || status === '5'){
                  statusColorStyle.color = 'red';
                  statusRussia = 'Нет в 1С'
                }else{
                  statusClassName = '';
                  statusColorStyle.color = 'green';
                  statusRussia = 'Новый'
                }
              }
              if(profile.resStatus1C == '200'){
                statusColorStyle2.color = 'green'
              }

              var date = new Date(profile.updatedAt),
              getRefactDate = (a) => {
                  if((a + '').length == 1){
                      return '0' + a;
                  }
                  return a;
              },
              stringDate = `${getRefactDate(date.getDate())}.${getRefactDate(date.getMonth()+1)}.${date.getFullYear()}, ${getRefactDate(date.getHours())}:${getRefactDate(date.getMinutes())}`;

              for (var name in this.state.filter) {
                if(this.state.filter[name](profile, this.state.dataFilter)){
                  arrFilter[arrFilter.length] = true;
                }else{
                  arrFilter[arrFilter.length] = false;
                }
              }
              {/* console.log('arrFilter', arrFilter) */}
              for (var i = 0, l = arrFilter.length; i < l; i++) {
                if(arrFilter[i] === false){
                  return null;
                }
                if(i == l -1){
                  return(
                    <Link key={profile.sfid} to={`/admin/specialty/${this.props.specialty}/profile/${profile.id}/`} className={`SelectSpecialtiesOpen ${statusClassName} ProfilesList`} style={{display: 'flex', justifyContent: 'space-between', opacity: profile.formEnd ? '1' : '0.7'}}>
                      <div  className="Border" style={{width: '5%'}}></div>
                      <div className="Content" style={statusColorStyle}>{statusRussia}</div>
                      <div className="Border" style={{width: 1, height: 20, background: '#ccc'}}></div>
                      <div className="Content" style={{color: 'red', width: '20%'}}>{profile.city}</div>
                      <div className="Border" style={{width: 1, height: 20, background: '#ccc'}}></div>
                      <div className="Content" style={{width: '20%'}}>{profile.secondtName}</div>
                      <div className="Border" style={{width: 1, height: 20, background: '#ccc'}}></div>
                      <div className="Content" style={{width: '20%'}}>{profile.firstName}</div>
                      <div className="Border" style={{width: 1, height: 20, background: '#ccc'}}></div>
                      
                      
                      <div className="Content" style={{width: '25%'}}>{stringDate}</div>
                      <div className="Content" style={statusColorStyle2}>{profile.resStatus1C || '-'}</div>
                      <div className="Border" style={{width: '5%'}}></div>
                    </Link>
                  );
                }
              }
            })}
          </div>
        );
      }else{
        return <EmptyCat />
      }

    }else{
      return(
        <div className="loading"></div>
      );
    }
  }
});

export default List;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/List/index.jsx
 **/